/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { useFormik } from 'formik'
import { useEffect, useState, type KeyboardEvent } from 'react'
import { Link } from 'react-router-dom'
import * as Yup from 'yup'
import { success } from '../../../../Global/toast'
import Password from '../../../../_supplier/assets/media/auth/password.png'
import ShowPassword from '../../../../_supplier/assets/media/auth/showPassword.png'
import { PasswordMeterComponent } from '../../../../_supplier/assets/ts/components'
import APICallService from '../../../../api/apiCallService'
import { AUTH } from '../../../../api/apiEndPoints'
import { AuthJSON } from '../../../../api/apiJSON/auth'
import { auth } from '../../../../utils/toast'
import { setKey } from '../../../../Global/history'
import { authStorage } from '../../../../utils/storeString'
import { useAuth } from '../core/Auth'
import { authCardClassName } from '../AuthLayout'
import BrandLogo from '../../../../_supplier/assets/media/uTrade-logo.png'
import BackArrow from '../../../../_supplier/assets/media/svg_supplier/back arrow.svg'

const authFieldStyle = {
  display: 'flex',
  width: '416px',
  height: '56px',
  padding: '10px 20px',
  alignItems: 'center',
  gap: '10px',
  borderRadius: '12px',
  border: '1px solid var(--essentials-border, #E6E6E7)',
  background: 'var(--white, #FFF)',
} as const

const authInputStyle = {
  flex: 1,
  minWidth: 0,
  fontSize: '16px',
  background: 'transparent',
} as const

const authErrorStyle = {width: '416px', textAlign: 'start' as const}


const initialValues = {
  name: '',
  businessName: '',
  email: '',
  phoneNumber: '',
  password: '',
  acceptTerms: false,
}
const registrationSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Length should be minimum 3')
    .max(50, 'Length should be maximum 50')
    .required('Name is required'),
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Length should be minimum 3')
    .max(50, 'Length should be maximum 50')
    .required('Email is required'),
  businessName: Yup.string()
    .min(3, 'Length should be minimum 3')
    .max(50, 'Length should be maximum 50')
    .required('Business name is required'),
  phoneNumber: Yup.string()
    .min(6, 'Length should be minimum 6')
    .max(14, 'Length should be maximum 14')
    .required('Phone number is required'),
  password: Yup.string()
    .min(6, 'Length should be minimum 6')
    .max(15, 'Length should be maximum 15')
    .required('Password is required'),
})

export function SignUp() {
  const [loading, setLoading] = useState(false)
  const { saveAuth, saveCurrentUser } = useAuth()
  const [showPassword, setShowPassword] = useState(false)
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        let apiService = new APICallService(
          AUTH.REGISTER,
          AuthJSON.register({
            email: values.email,
            password: values.password,
            name: values.name,
            phone: values.phoneNumber,
            phoneCountry: '+255',
            businessName: values.businessName,
          })
        )
        let response = await apiService.callAPI()
        if (response) {
          saveAuth(response.token)
          saveCurrentUser(response.user)
          setKey(authStorage.showSupplierRegistrationWelcome, true)
          success(auth.register)
        }
      } catch (error) {
        console.log(error)
        saveAuth(undefined)
        setStatus('The registration details is incorrect 1')
      }
      setSubmitting(false)
      setLoading(false)
    },
  })

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])

  const handlePhoneKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    const allowedKeys = new Set([
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End',
    ])

    if (allowedKeys.has(event.key) || event.ctrlKey || event.metaKey) {
      return
    }

    if (!/^[0-9.]$/.test(event.key)) {
      event.preventDefault()
    }
  }

  return (
    
    <form
      className={clsx(authCardClassName, 'form w-100 position-relative')}
      style={{paddingRight: '86px'}}
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signup_form'
    >
      <style>{`
        #kt_login_signup_form .login-field-input {
          background: transparent !important;
          border: none;
          outline: none;
          box-shadow: none;
        }
        #kt_login_signup_form .login-field-input:-webkit-autofill,
        #kt_login_signup_form .login-field-input:-webkit-autofill:hover,
        #kt_login_signup_form .login-field-input:-webkit-autofill:focus,
        #kt_login_signup_form .login-field-input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
          box-shadow: 0 0 0 1000px #fff inset !important;
          -webkit-text-fill-color: inherit !important;
          transition: background-color 99999s ease-in-out 0s;
        }
      `}</style>
      <div className='mb-4 sm:mb-6'>
        <img
          src={BrandLogo}
          alt='logo'
          width={150}
          height={50}
          className='mb-3 mx-auto d-block'
          style={{maxWidth: '70%', height: 'auto'}}
        />
        <h1 className='text-dark text-center fw-700 mb-3 text-[22px] sm:text-[26px] lg:text-[28px]'>
          Register as Supplier
        </h1>
        <p className='text-center fw-normal text-sm sm:text-base'>
          Create you account to manage POs & products
        </p>
      </div>

      <div className='flex flex-col items-center w-full'>
        <div className='fv-row mb-3 w-full flex flex-col items-center'>
          <div style={authFieldStyle}>
            <input
              placeholder='Name'
              {...formik.getFieldProps('name')}
              value={formik.values.name.trimStart()}
              onChange={(e) => formik.handleChange(e)}
              className='login-field-input'
              style={authInputStyle}
              type='text'
              autoComplete='off'
            />
          </div>
          {formik.touched.name && formik.errors.name && (
            <div className='fv-plugins-message-container' style={authErrorStyle}>
              <span role='alert' className='text-danger fs-14 fw-500'>
                {formik.errors.name}
              </span>
            </div>
          )}
        </div>

        <div className='fv-row mb-3 w-full flex flex-col items-center'>
          <div style={authFieldStyle}>
            <input
              placeholder='Business Name'
              {...formik.getFieldProps('businessName')}
              value={formik.values.businessName.trimStart()}
              onChange={(e) => formik.handleChange(e)}
              className='login-field-input'
              style={authInputStyle}
              type='text'
              autoComplete='off'
            />
          </div>
          {formik.touched.businessName && formik.errors.businessName && (
            <div className='fv-plugins-message-container' style={authErrorStyle}>
              <span role='alert' className='text-danger fs-14 fw-500'>
                {formik.errors.businessName}
              </span>
            </div>
          )}
        </div>

        <div className='fv-row mb-3 w-full flex flex-col items-center'>
          <div style={authFieldStyle}>
            <input
              placeholder='Email'
              {...formik.getFieldProps('email')}
              value={formik.values.email.trimStart()}
              onChange={(e) => formik.handleChange(e)}
              className='login-field-input'
              style={authInputStyle}
              type='email'
              autoComplete='off'
            />
          </div>
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container' style={authErrorStyle}>
              <span role='alert' className='text-danger fs-14 fw-500'>
                {formik.errors.email}
              </span>
            </div>
          )}
        </div>

        <div className='fv-row mb-3 w-full flex flex-col items-center'>
          <div style={authFieldStyle}>
            <span className='fs-14 sm:text-base fw-500 text-dark' style={{flexShrink: 0}}>
              +255
            </span>
            <input
              placeholder='Phone number'
              {...formik.getFieldProps('phoneNumber')}
              value={formik.values.phoneNumber.trimStart()}
              onChange={(e) => formik.handleChange(e)}
              onKeyDown={handlePhoneKeyDown}
              className='login-field-input'
              style={authInputStyle}
              type='text'
              autoComplete='off'
            />
          </div>
          {formik.touched.phoneNumber && formik.errors.phoneNumber && (
            <div className='fv-plugins-message-container' style={authErrorStyle}>
              <span role='alert' className='text-danger fs-14 fw-500'>
                {formik.errors.phoneNumber}
              </span>
            </div>
          )}
        </div>

        <div className='fv-row mb-6 w-full flex flex-col items-center'>
          <div style={authFieldStyle}>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder='Password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              value={formik.values.password.trimStart()}
              onChange={(e) => formik.handleChange(e)}
              className='login-field-input'
              style={authInputStyle}
            />
            {showPassword ? (
              <img
                height={15}
                width={25}
                src={ShowPassword}
                onClick={() => setShowPassword(!showPassword)}
                alt=''
                style={{cursor: 'pointer', flexShrink: 0}}
              />
            ) : (
              <img
                height={15}
                width={25}
                src={Password}
                onClick={() => {
                  formik.touched.password ? setShowPassword(!showPassword) : setShowPassword(false)
                }}
                alt=''
                style={{cursor: 'pointer', flexShrink: 0}}
              />
            )}
          </div>
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container' style={authErrorStyle}>
              <span role='alert' className='text-danger fs-14 fw-500'>
                {formik.errors.password}
              </span>
            </div>
          )}
        </div>

        {formik.status && (
          <div className='mb-3' style={authErrorStyle}>
            <span role='alert' className='text-danger fs-14 fw-500'>
              {formik.status}
            </span>
          </div>
        )}

        <div className='w-full flex justify-center mt-4'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className={clsx('form-control form-control-custom text-center border-0')}
            style={{
              display: 'flex',
              width: '416px',
              height: '56px',
              padding: '10px 20px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              background: '#1B74E4',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: '600',
              color: '#fff',
              opacity: formik.isSubmitting || !formik.isValid ? 0.5 : 1,
              cursor: formik.isSubmitting || !formik.isValid ? 'not-allowed' : 'pointer',
            }}
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label fs-16 fw-bolder'>Register</span>}
            {loading && (
              <span className='indicator-progress indicator-label fs-16 fw-600'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>

      <div className='d-flex justify-content-center' style={{padding: '40px'}}>
        <Link
          to='/auth/login'
          className='text-[#1B74E4] font-bold text-sm sm:text-[16px]'
          style={{
            display: 'flex',
            width: '416px',
            height: '56px',
            padding: '16px 22px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            borderRadius: '12px',
            border: '1px solid var(--brand-primary-blue, #1B74E4)',
            background: 'var(--white, #FFF)',
          }}
        >
          <img src={BackArrow} alt='' width={18} height={18} />
          Back to Login
        </Link>
      </div>
    </form>
  )
}
